export type PropertyPrefilterValue =
  | number[]
  | number
  | string[]
  | string
  | null
  | undefined;

export type QueryWithPropertyPrefilter = {
  propertyId?: PropertyPrefilterValue;
};

export function normalizePropertyPrefilterQuery<T extends QueryWithPropertyPrefilter>(query: T): T {
  const normalizedPropertyId = normalizePropertyId(query.propertyId);

  if (normalizedPropertyId === query.propertyId) {
    return query;
  }

  return {
    ...query,
    propertyId: normalizedPropertyId,
  };
}

function normalizePropertyId(
  propertyId: PropertyPrefilterValue,
): PropertyPrefilterValue {
  if (propertyId === undefined || propertyId === null) {
    return propertyId;
  }

  if (Array.isArray(propertyId) && propertyId.every(value => typeof value === 'number')) {
    return propertyId;
  }

  if (typeof propertyId === 'number') {
    return [propertyId];
  }

  const parsedIds = tryParsePropertyIds(propertyId);

  return parsedIds ?? propertyId;
}

function tryParsePropertyIds(
  propertyId: string[] | string,
): number[] | null {
  const values = Array.isArray(propertyId) ? propertyId : [propertyId];
  const parsedValues: number[] = [];

  for (const value of values) {
    const parts = value
      .split(',')
      .map(part => part.trim())
      .filter(Boolean);

    for (const part of parts) {
      const parsedValue = Number(part);

      if (!Number.isInteger(parsedValue)) {
        return null;
      }

      parsedValues.push(parsedValue);
    }
  }

  return parsedValues;
}
